export default __webpack_public_path__ + "static/media/nordstorm.c56434fe.svg";